module.exports = __webpack_public_path__ + "static/img/page5-bg.511eda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page5-bg.png
// module id = Smvy
// module chunks = 216